import styled from 'styled-components';
import { BasicEntity } from '../EntityLabels';

interface IProps {
  emails: string[];
  onRemove: (email: string) => void;
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const EmailTagList = ({ emails, onRemove }: IProps) => (
  <Container>
    {emails.map((email) => (
      <BasicEntity key={email} onClear={() => onRemove(email)}>
        {email}
      </BasicEntity>
    ))}
  </Container>
);

export default EmailTagList;
